import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, throwError, timer } from 'rxjs';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { NotyService } from '../../noty.service';
import { ApolloQueryResult } from '@apollo/client/core';
import { GraphQLError } from 'graphql';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements HttpInterceptor {
  constructor(private notyService: NotyService) {}
  intercept(
    request: HttpRequest<ApolloQueryResult<unknown>>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((res) => {
        // Apollo would normally do this for us downstream
        // This is done here so that the default error handling doesnt need to be duplicated for HTTP and GQL
        if (
          res instanceof HttpResponse &&
          res.body?.errors &&
          res.body?.errors.length > 0
        ) {
          throw new GraphQLError(res.body.errors[0].message);
        }
        return res;
      }),
      catchError((err) => {
        err.defaultHandler = timer(0).subscribe(() => {
          const errorMessage = err.message || err.error?.type || err.statusText;
          this.notyService.error(errorMessage);
        });
        err.notyService = this.notyService;
        return throwError(() => err);
      }),
    );
  }
}
